import { render, staticRenderFns } from "./TheMenuSection.vue?vue&type=template&id=598e5978&scoped=true&"
import script from "./TheMenuSection.vue?vue&type=script&lang=js&"
export * from "./TheMenuSection.vue?vue&type=script&lang=js&"
import style0 from "./TheMenuSection.vue?vue&type=style&index=0&id=598e5978&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598e5978",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VDivider,VList,VSubheader})
